import React, { useCallback } from 'react';

import { Enums, useSystem } from '@core';
import { GridViewports, Layout } from '@core/types/ViewportGridType';
import { LoadingIndicatorProgress } from '@ui';

// Hiển thị loading trên viewport grid
const ViewportGridLoadingProgress = ({
	layout,
	viewports
}: {
	layout: Layout;
	viewports: GridViewports;
}) => {
	const { extensionManager } = useSystem();
	const { numCols, numRows } = layout;

	const { component: RemoteRenderLoadingIndicatorProgress } = extensionManager.getModuleEntry(
		'@extensions/remote-render.viewportModule.remoteRenderViewportLoading'
	);

	const renderLoadingProgress = useCallback(() => {
	
		if (viewports) {
			const viewport = viewports.values().next().value;
			if (!viewport) {
				console.warn('No viewport found in viewports');
				return <></>;
			}
			const viewportType = viewport.viewportOptions?.viewportType;
			// có component loading riêng cho remote viewport
			if (viewportType === Enums.ViewportTypes.REMOTE_RENDER) {
			return (
					<RemoteRenderLoadingIndicatorProgress />
				);
			}
			if (!numRows || !numCols) {
				return <LoadingIndicatorProgress className={'h-full w-full'} />;
			}
			return <></>;
		}

		return <LoadingIndicatorProgress className={'h-full w-full'} />;
	}, [extensionManager, numCols, numRows, viewports]);
	return <>{renderLoadingProgress()}</>;
};

export default ViewportGridLoadingProgress;
